export default __webpack_public_path__ + "static/media/muro.e337963c.png";